import styled from 'styled-components';

export const StyledActivityItem = styled.div`
	@media (min-width: 767px) {
		padding: 10px;
	}
	color: ${({ theme }) => theme.colors.text};
	height: 85px;
	&:hover {
		cursor: pointer;
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
	padding-top: 10px;

	background-color: ${({ theme, $selected, $readStatus }) => {
		if ($selected) {
			return theme.colors.primaryLight;
		}
		if ($readStatus) {
			return '#E4EDF4';
		}
		return theme.colors.background;
	}};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	border-radius: 2px;
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		padding-left: 15px;
		font-size: 13px;
	}
`;

export const StyledBlock = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	height: 100%;
	width: 100%;
`;

export const StyledBlockCenter = styled(StyledBlock)`
	justify-content: center;
`;

export const StyledActionContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: auto;
	margin-right: 20px;
`;

export const StyledInformationContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	height: 100%;
	width: auto;
`;

export const StyledRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	height: auto;
	width: 100%;
`;

export const StyledRowCenter = styled(StyledRow)`
	justify-content: center;
`;

export const StyledItem = styled.span`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 10px;
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		margin-right: 35px;
	}
`;

export const StyledBoldItem = styled(StyledItem)`
	font-weight: bold;
`;

export const StyledHeader = styled(StyledBoldItem)`
	display: flex;
	color: ${({ theme }) => theme.colors.primary};
`;

export const StyledBottomBar = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 4px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.grey};
`;
